import { render, staticRenderFns } from "./restaurantCategoryForm.vue?vue&type=template&id=0981db68&lang=en&"
import script from "./restaurantCategoryForm.vue?vue&type=script&lang=js&"
export * from "./restaurantCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./restaurantCategoryForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports